import styled from "styled-components";

import { Card } from "antd";

import { colors } from "@app/theme.ts";

export const CmtSectionCard = styled(Card)`
  border-color: ${colors.border};

  .ant-card-head {
    border-bottom: none;
    min-height: auto;
    padding-top: 1.25rem;
  }

  .ant-card-head-title {
    font-size: 1.05rem;
    font-weight: 700;
  }

  .ant-card-body {
    padding-top: 0.75rem;
  }
`;
